export default __webpack_public_path__ + "static/media/dtsu5168_ct_power_wiring.255f8eb2.jpg";